const doc = [({"no":({"js":({"components":({"users":({"sign_out":({"sign_out":"Logg ut", "you_were_signed_out":"Du ble logget ut"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;